import {Portal} from 'components/portal/Portal'
import {Question} from 'components/question'
import {useRouter} from 'next/router'
import {z} from 'zod'

const zQuery = z.object({
  slug: z.array(z.string()).min(1)
})

export default function QuestionPage() {
  const router = useRouter()
  if (!router.isReady) return <></>
  const {slug} = zQuery.parse(router.query)
  const question_id = slug[0]
  if (question_id == null) return <></>
  return (
    <Portal noScroll>
      <Question question_id={question_id} />
    </Portal>
  )
}
